import service from './service'

export const login = (params = {}) =>
  service.post('/api/login.do?t=' + Date.now(), params)

export const logout = (params = {}) =>
  service.post('/api/logout.do?t=' + Date.now(), params)
// ---地址省市区管理---

// 省（直辖市）
export const provinceList = (params = {}) =>
  service.post('/api/address/province.do?t=' + Date.now(), params)

// 市
export const cityList = (params = {}) =>
  service.post('/api/address/city.do?t=' + Date.now(), params)

// 区县
export const areaList = (params = {}) =>
  service.post('/api/address/area.do?t=' + Date.now(), params)

// 货主和物流 公司列表
export const allCompanyList = (params = {}) =>
  service.post('/api/adminUser/vhbCompangList.do?t=' + Date.now(), params)

// ---货源与车源---

// 初级货源
export const lowSource = (params = {}) =>
  service.post('/api/admin/quickCargo/viewCargo.do?t=' + Date.now(), params)

// 高级货源列表
export const heightSource = (params = {}) =>
  service.post('/api/VhbGoodsSenior/goodsSeniorList.do?t=' + Date.now(), params)

// 高级货源列表权限用户
export const userPermission = (params = {}) =>
  service.post(
    '/api/VhbGoodsSenior/goodsSeniorAddUserLists.do?t=' + Date.now(),
    params
  )

// 高级货源批量保存权限用户
export const heightSave = (params = {}) =>
  service.post(
    '/api/VhbGoodsSenior/addGoodsSeniorAddUser.do?t=' + Date.now(),
    params
  )

// 高级货源批量删除权限用户
export const heightDelete = (params = {}) =>
  service.post(
    '/api/VhbGoodsSenior/updateGoodsSeniorAddUser.do?t=' + Date.now(),
    params
  )

// 高级货源-货源匹配车辆列表
export const heightDriverOrder = (params = {}) =>
  service.post(
    '/api/VhbGoodsSenior/driverOrderLists.do?t=' + Date.now(),
    params
  )

// 高级货源- 匹配车辆信息
export const heightCarOrder = (params = {}) =>
  service.post('/api/VhbGoodsSenior/NewpreMatch.do?t=' + Date.now(), params)

// 高级货源- 匹配车辆信息匹配/批量匹配接口
export const heightMatch = (params = {}) =>
  service.post('/api/VhbGoodsSenior/NewmakeOrders.do?t=' + Date.now(), params)

// 高级货源- 查询服务费
export const searchMatch = (params = {}) =>
  service.post('/api/VhbDriverOrder/matchAmount.do?t=' + Date.now(), params)

// --------------专线招标货源
// 获取专线招标列表
export const privatelist = (params = {}) =>
  service.post(
    '/api/VhbGoodsDedicated/getGoodsDedicatedList.do?t=' + Date.now(),
    params
  )

// 专线招标货源-投标详情
export const privateDetail = (params = {}) =>
  service.post('/api/VhbGoodsDedicated/getBidInfo.do?t=' + Date.now(), params)

// 专线招标货源查看车辆
export const privateCarDetail = (params = {}) =>
  service.post('/api/VhbGoodsDedicated/getCarList.do?t=' + Date.now(), params)

// 后台询价货源列表
export const enquiryList = (params = {}) =>
  service.post('/api/admin/inquiryPriceCargo/view.do?t=' + Date.now(), params)

// 货源编号查询报价
export const priceInfo = (params = {}) =>
  service.post('/api/admin/VhbCargoOffer/viewByNum.do?t=' + Date.now(), params)

// 初级车源
export const shareCar = (params = {}) =>
  service.post('/api/admin/quickOption/viewOption.do?t=' + Date.now(), params)

// -----------返程推荐

// // 获取返程推荐列表
export const proposedList = (params = {}) =>
  service.post('/api/vehicleReturn/list.do?t=' + Date.now(), params)

// 待推荐列表-返程推荐xinxi
export const proposedRouteInfo = (params = {}) =>
  service.post('/api/returnLine/getVehicleReturn.do?t=' + Date.now(), params)

// 待推荐列表-返程路线详情
export const proposedRoute = (params = {}) =>
  service.post('/api/returnLine/recommend.do?t=' + Date.now(), params)

// 待推荐列表-查看路线详情
export const proposedRodeDetail = (params = {}) =>
  service.post('/api/returnLine/lineDetails.do?t=' + Date.now(), params)

// 获取返程推荐-已推荐记录列表
export const recommendList = (params = {}) =>
  service.post('/api/admin/routeReturn/List.do?t=' + Date.now(), params)

// 已推荐列表-查看详情

export const getRecommendDetail = (params = {}) =>
  service.post('/api/admin/routeReturn/key.do?t=' + Date.now(), params)

// 已推荐列表-查看详情-线路详情
export const getRecommendRoleDetail = (params = {}) =>
  service.post('/apiadmin/routeReturn/routeList.do?t=' + Date.now(), params)

// 已推荐列表-运单记录
export const getWaybillRecord = (params = {}) =>
  service.post(
    '/api/admin/routeReturn/selectOrderList.do?t=' + Date.now(),
    params
  )

// 匹配车辆
export const matchCars = (params = {}) =>
  service.post('/api/returnLine/matchGoods.do?t=' + Date.now(), params)

// 取消推荐
export const cancleRoute = (params = {}) =>
  service.post('/api/admin/routeReturn/cancelRoute.do?t=' + Date.now(), params)

// 运单记录查看装卸车辆图片
export const driverOrderImages = (params = {}) =>
  service.post(
    '/api/admin/routeReturn/driverOrderImgs.do?=' + Date.now(),
    params
  )

// ---运单管理---

// 高级货源运单
export const heightWaybill = (params = {}) =>
  service.post(
    '/api/VhbCompanyOrder/companyOrderList.do?t=' + Date.now(),
    params
  )

// 运单详情-货源信息
export const waybillOrderView = (params = {}) =>
  service.post(
    '/api/VhbCompanyOrder/getVhbCompanyAllOrderView.do?t=' + Date.now(),
    params
  )

// 运单详情-车辆运单上传图片
export const waybillImages = (params = {}) =>
  service.post('/api/VhbDriverOrder/vehicleImgs.do?t=' + Date.now(), params)

// 运单详情-高级货源车辆运单
export const waybillDriver = (params = {}) =>
  service.post(
    '/api/VhbDriverOrder/driverOrderLists.do?t=' + Date.now(),
    params
  )

// 运单详情-取消车辆运单
export const waybillCancel = (params = {}) =>
  service.post(
    '/api/VhbDriverOrder/cancelDriverOrder.do?t=' + Date.now(),
    params
  )

// 运单详情-运单对应的轨迹
export const waybillTrack = (params = {}) =>
  service.post('/api/VhbDriverOrder/trajectory.do?t=' + Date.now(), params)

// 专线招标运单
// 获取专线招标运单
export const getPrivateWaybill = (params = {}) =>
  service.post(
    '/api/vhbDedicatedOrder/getGoodsDedicatedList.do?t=' + Date.now(),
    params
  )

// 专线招标运单详情
export const getPrivateDetail = (params = {}) =>
  service.post(
    '/api/vhbDedicatedOrder/getDedicatedOrderList.do?t=' + Date.now(),
    params
  )

// 专线招标车辆详情
export const getPrivateCarDetail = (params = {}) =>
  service.post(
    '/api/vhbDedicatedOrder/getTruckOrderList.do?t=' + Date.now(),
    params
  )

// 专线招标车辆轨迹
export const getPrivateTrack = (params = {}) =>
  service.post(
    '/api/vhbDedicatedOrder/getTruckOrderLocation.do?t=' + Date.now(),
    params
  )

// 专线招标装卸车辆图片
export const getPrivateImg = (params = {}) =>
  service.post(
    '/api/vhbDedicatedOrder/getTruckOrderPicture.do?t=' + Date.now(),
    params
  )

// 专线招标评价
export const getPrivateEvaluate = (params = {}) =>
  service.post(
    '/api/vhbDedicatedOrder/getOrderComments.do?t=' + Date.now(),
    params
  )

// ---信息维护管理---

// 工厂源管理

// 获取工厂源列表
export const factoryList = (params = {}) =>
  service.post(
    '/api/VhbFactoryResource/getFactoryResourceList.do?t=' + Date.now(),
    params
  )

// 添加工厂源
export const addFactory = (params = {}) =>
  service.post(
    '/api/VhbFactoryResource/addVhbFactoryResource.do?t=' + Date.now(),
    params
  )

// 修改获取工厂源信息
export const getFactory = (params = {}) =>
  service.post(
    '/api/VhbFactoryResource/getFactoryResource.do?t=' + Date.now(),
    params
  )

// 更新工厂源信息
export const updateFactory = (params = {}) =>
  service.post(
    '/api/VhbFactoryResource/updateFactoryResource.do?t=' + Date.now(),
    params
  )

// 删除工厂源
export const deleteFactory = (params = {}) =>
  service.post(
    '/api/VhbFactoryResource/deleteFactoryResource.do?t=' + Date.now(),
    params
  )

// ----------危险品安全卡

// 获取安全卡列表
export const getSafetyCardList = (params = {}) =>
  service.post(
    '/api/VhbChemicalSafetyCard/getSafetyCardList.do?t=' + Date.now(),
    params
  )

// 安全卡详情页
export const getSafetyCardDetail = (params = {}) =>
  service.post(
    '/api/VhbChemicalSafetyCard/getSafetyCardDetail.do?t=' + Date.now(),
    params
  )

// 获取安全卡图片
export const getPiclist = (params = {}) =>
  service.post(
    '/api/VhbChemicalSafetyCard/getPicture.do?t=' + Date.now(),
    params
  )

// 添加安全卡信息
export const addSafetyCaed = (params = {}) =>
  service.post(
    '/api/VhbChemicalSafetyCard/saveSafetyCard.do?t=' + Date.now(),
    params
  )

// 修改安全卡信息
export const updateSafetyCard = (params = {}) =>
  service.post(
    '/api/VhbChemicalSafetyCard/updateSafetyCard.do?t=' + Date.now(),
    params
  )

// 删除安全卡信息
export const deleteSafetyCard = (params = {}) =>
  service.post(
    '/api/VhbChemicalSafetyCard/deleteSafetyCard.do?t=' + Date.now(),
    params
  )

// -----------------省市区管理
// 获取省市区列表
export const getArea = (params = {}) =>
  service.post('/api/admin/getArea.do?t=' + Date.now(), params)

// 获取信息（市）
export const getProvinceInfo = (params = {}) =>
  service.post('/api/admin/getVhbAddressProvince.do?t=' + Date.now(), params)

// 添加市
export const addCity = (params = {}) =>
  service.post('/api/admin/addVhbAddressCity.do?t=' + Date.now(), params)

// 修改市获取信息
export const updateGetCity = (params = {}) =>
  service.post('/api/admin/getVhbAddressCityInfo.do?t=' + Date.now(), params)

// 修改市
export const updateCity = (params = {}) =>
  service.post('/api/admin/updateVhbAddressCity.do?t=' + Date.now(), params)

// 删除市
export const deleteCity = (params = {}) =>
  service.post('/api/admin/deleteVhbAddressCity.do?t=' + Date.now(), params)

// 获取信息（区）
export const getCityInfo = (params = {}) =>
  service.post('/api/admin/getVhbAddressCity.do?t=' + Date.now(), params)

// 添加区
export const addArea = (params = {}) =>
  service.post('/api/admin/addVhbAddressArea.do?t=' + Date.now(), params)

// 删除区
export const deleteArea = (params = {}) =>
  service.post('/api/admin/deleteVhbAddressArea.do?t=' + Date.now(), params)

// 修改区获取信息
export const updateGetArea = (params = {}) =>
  service.post('/api/admin/getCityArea.do?t=' + Date.now(), params)

// 修改区信息
export const updateArea = (params = {}) =>
  service.post('/api/admin/updateVhbAddressArea.do?t=' + Date.now(), params)

// ---数据统计---

// 公司分类统计
export const conpanyStats = (params = {}) =>
  service.post('/api/vhb/company/companyTimes.do?t=' + Date.now(), params)

// 车载设备统计
export const carkit = (params = {}) =>
  service.post('/api/vhb/company/companyValue.do?t=' + Date.now(), params)

// ----资源定位分布
// 资源列表
export const sourceList = (params = {}) =>
  service.get('/api/admin/VhbResourceLocation.do?t=' + Date.now(), {
    params: params
  })

// 获取轨迹
export const getTrack = (params = {}) =>
  service.post('/api/admin/location.do?t' + Date.now(), params)

// 工厂查询
export const factorySearch = (params = {}) =>
  service.post('/api/admin/LikeFactory.do', params)

// 货源查询/运单
export const goodsSearch = (params = {}) =>
  service.post('/api/admin/likeGoods.do', params)

// 空车查询
export const emptyCarSearch = (params = {}) =>
  service.post('/api/admin/likeEmptyDriver.do.do', params)

// 重车查询
export const busyCarSearch = (params = {}) =>
  service.post('/api/admin/likeBusyDriver.do', params)

// ---用户信息管理---

// 用户列表
export const userList = (params = {}) =>
  service.post('/api/adminUser/appUserList.do?t=' + Date.now(), params)

// 添加、修改、禁用用户列表
export const userListChange = (params = {}) =>
  service.post('/api/adminUser/vhbUserDataHandle.do?t=' + Date.now(), params)

// 查询用户详情
export const userListDetail = (params = {}) =>
  service.post('/api/adminUser/vhbCompangDetails.do?t=' + Date.now(), params)

// 登记记录
export const rekodBancian = (params = {}) =>
  service.post(
    '/api/VhbUserLoginRecord/loginRecordList.do?t=' + Date.now(),
    params
  )

// ----------公司列表

// 获取公司列表
// export const companyList = (params = {}) => service.get('/api/vhb/company/getCompanyList.do?t=' + Date.now(), {params: params})
export const companyList = (params = {}) =>
  service.post('/api/vhb/company/getCompanyList.do?t=' + Date.now(), params)

// 公司列表运营路线
export const operationList = (params = {}) =>
  service.post('/api/vhb/company/getCompanyRote.do?t=' + Date.now(), params)

// 审核公司
export const auditCompany = (params = {}) =>
  service.post('/api/vhb/company/auditingCompany.do?t=' + Date.now(), params)

// 物流端获取保证金信息
export const getEarnest = (params = {}) =>
  service.post('/api/vhb/company/getBondDetails.do?t=' + Date.now(), params)

// 物流保证金审核
export const auditEarnest = (params = {}) =>
  service.post('/api/vhb/company/auditBond.do?t=' + Date.now(), params)

// 添加公司
export const addCompany = (params = {}) =>
  service.post('/api/vhb/company/addCompany.do?t=' + Date.now(), params)

// 修改公司获取信息
export const getCompanyDetail = (params = {}) =>
  service.post('/api/vhb/company/getCompanyById.do?t=' + Date.now(), params)

// 修改公司信息
export const updateCompanyDetail = (params = {}) =>
  service.post('/api/vhb/company/updateCompany.do?t=' + Date.now(), params)

// 获取授权审核列表
export const authorizationList = (params = {}) =>
  service.post('/api/authorizationAdmin/auditList.do?t=' + Date.now(), params)

// 获取授权审核详情页
export const authorizationDetail = (params = {}) =>
  service.post(
    '/api/authorizationAdmin/authorizationDetails.do?t=' + Date.now(),
    params
  )

// 授权审核
export const authorizationAudit = (params = {}) =>
  service.post(
    '/api/authorizationAdmin/authorizationAudit.do?t=' + Date.now(),
    params
  )

// 用户金融审核

// 获取用户金融列表
export const getFinancial = (params = {}) =>
  service.post(
    '/api/userFinancialAdmin/getUserFinancialList.do?t=' + Date.now(),
    params
  )

// 用户金融认证
export const financialAudie = (params = {}) =>
  service.post(
    '/api/userFinancialAdmin/auditingUserFinancial.do?t=' + Date.now(),
    params
  )

// 获取修改用户金融页面
export const getUpdateFinancialInfo = (params = {}) =>
  service.post(
    '/api/userFinancialAdmin/toUpdateUserFinancial.do?t=' + Date.now(),
    params
  )

// 修改用户金融页面
export const updateFinancial = (params = {}) =>
  service.post(
    '/api/userFinancialAdmin/updateUserFinancial.do?t=' + Date.now(),
    params
  )

// 确认开户
export const confirmAccouont = (params = {}) =>
  service.post(
    '/api/userFinancialAdmin/reloadDataAction.do?t=' + Date.now(),
    params
  )

// 司机车辆信息列表
export const driversList = (params = {}) =>
  service.post('/api/admin/driver/view.do?t=' + Date.now(), params)

// 禁用及解禁司机车辆信息
export const disableDrivers = (params = {}) =>
  service.post('/api/admin/driver/driversType.do?t=' + Date.now(), params)

// 修改司机车辆信息
export const updateDrivers = (params = {}) =>
  service.post('/api/admin/driver/update.do?t=' + Date.now(), params)

// 保存司机车辆信息
export const saveDrivers = (params = {}) =>
  service.post('/api/admin/driver/save.do?t=' + Date.now(), params)

// 删除司机车辆信息
export const deleteDrivers = (params = {}) =>
  service.post('/api/admin/driver/delete.do?t=' + Date.now(), params)

// -----------金融管理---

// 添加银行信息
export const addBank = (params = {}) =>
  service.post('/api/admin/bank/add.do?t=' + Date.now(), params)

// 删除银行信息
export const deleteBank = (params = {}) =>
  service.post('/api/admin/bank/delete.do?t=' + Date.now(), params)

// 修改银行信息
export const updateBank = (params = {}) =>
  service.post('/api/admin/bank/update.do?t=' + Date.now(), params)

// 保存银行信息
export const saveBank = (params = {}) =>
  service.post('/api/admin/bank/save.do?t=' + Date.now(), params)

// 后台查看所有银行信息
export const bankList = (params = {}) =>
  service.post('/api/admin/bank/view.do?t=' + Date.now(), params)

// -----------金融公司管理

// 获取金融公司信息
export const financialfirmList = (params = {}) =>
  service.post('/api/admin/bankCompany/view.do?t=' + Date.now(), params)

// 添加金融公司
export const addFinancialfirm = (params = {}) =>
  service.post('/api/admin/bankCompany/add.do?t=' + Date.now(), params)

// 获取修改金融公司信息
export const getChangeFinancialFirm = (params = {}) =>
  service.post('/api/admin/bankCompany/update.do?t=' + Date.now(), params)

// 保存修改金融公司信息
export const saveChangeFinancialFirm = (params = {}) =>
  service.post('/api/admin/bankCompany/save.do?t=' + Date.now(), params)

// 删除金融公司
export const deleteFinancialfirm = (params = {}) =>
  service.post('/api/admin/bankCompany/delete.do?t=' + Date.now(), params)

// 查看金融申请
export const bankapplyList = (params = {}) =>
  service.post('/api/admin/bankApply/view.do?t=' + Date.now(), params)

// 审核金融申请
export const auditBankapply = (params = {}) =>
  service.post('/api/admin/bankApply/audit.do?t=' + Date.now(), params)

// 查看金融申请发票信息
export const receiptBankapply = (params = {}) =>
  service.post(
    '/api/admin/bankApply/financialInvoice.do?t=' + Date.now(),
    params
  )

// 获取修改金融信息列表
export const getChangeBankapply = (params = {}) =>
  service.post('/api/admin/bankApply/update.do?t=' + Date.now(), params)

// 保存修改金融信息列表
export const saveChangeBankapply = (params = {}) =>
  service.post('/api/admin/bankApply/save.do?t=' + Date.now(), params)

// 同步涌泉数据
export const dataSynchronization = (params = {}) =>
  service.post(
    '/api/admin/bankApply/dataSynchronization.do?t=' + Date.now(),
    params
  )

// ---系统管理---

// ----------邮箱列表

// 邮箱列表
export const emailList = (params = {}) =>
  service.get('/api/admin/email/getList.do?t=' + Date.now(), {
    params: params
  })

// 添加邮箱
export const addEmail = (params = {}) =>
  service.post('/api/admin/email/addEmail.do?t=' + Date.now(), params)

// 删除邮箱
export const deleteEmail = (params = {}) =>
  service.post('/api/admin/email/deleteEmail.do?t=' + Date.now(), params)

// 修改邮箱
export const updateEmail = (params = {}) =>
  service.post('/api/admin/email/updateEmail.do?t=' + Date.now(), params)

// 查询邮箱姓名
export const searchEmail = (params = {}) =>
  service.post('/api/admin/email/likeEmailByName.do?t=' + Date.now(), params)

// 禁用与解禁邮箱状态
export const disableEmail = (params = {}) =>
  service.post('/api/admin/email/disableEmail.do?t=' + Date.now(), params)

// -----------banner

// 获取banner列表
export const bannerList = (params = {}) =>
  service.get('/api/admin/getVhBannerList.do?t=' + Date.now(), {
    params: params
  })

// 禁用banner
export const disableBanner = (params = {}) =>
  service.post('/api/admin/disabledBanner.do?t=' + Date.now(), params)

// 增加banner
export const addBanner = (params = {}) =>
  service.post('/api/admin/addVhbBanner.do?t=' + Date.now(), params)

// 修改banner
export const changeBanner = (params = {}) =>
  service.get('/api/admin/updateInfo.do?t=' + Date.now(), {
    params: params
  })

// 保存修改Banner
export const updateBanner = (params = {}) =>
  service.post('/api/admin/updateVhbBanner.do?t=' + Date.now(), params)

// 上传图片
export const uploadImg = (params = {}) =>
  service.post('/api/admin/upload.do?t=' + Date.now(), params)

// 删除banner
export const deleteBanner = (params = {}) =>
  service.post('/api/admin/deleteBanner.do?t=' + Date.now(), params)

// ------------分享管理

// 获取分享管理信息
export const shareList = (params = {}) =>
  service.get('/api/admin/vhbShareGetList.do?t=' + Date.now(), {
    params: params
  })

// 增加分享管理
export const addShare = (params = {}) =>
  service.post('/api/admin/vhbShareAdd.do?t=' + Date.now(), params)

// 修改分享管理
export const updateShare = (params = {}) =>
  service.post('/api/admin/vhbShareInfo.do?t=' + Date.now(), params)

// 保存修改分享管理
export const saveUpdateShare = (params = {}) =>
  service.post('/api/admin/vhbShareUpdate.do?t=' + Date.now(), params)

// 删除分享信息
export const deleteShare = (params = {}) =>
  service.post('/api/admin/vhbShareDelete.do?t=' + Date.now(), params)

// --------------版本管理

// 获取版本列表
export const versionList = (params = {}) =>
  service.get('/api/admin/getVhbVersionList.do?t=' + Date.now(), {
    params: params
  })

// 添加版本信息
export const addVersion = (params = {}) =>
  service.post('/api/admin/addVhbVersion.do?t=' + Date.now(), params)

// 修改版本信息(获取)
export const updateVersion = (params = {}) =>
  service.post('/api/admin/getVhbVersion.do?t=' + Date.now(), params)

// 删除版本信息
export const deleteVersion = (params = {}) =>
  service.post('/api/admin/deleteVhbVersion.do?t=' + Date.now(), params)

// 禁用及解禁版本信息
export const disableVersion = (params = {}) =>
  service.post('/api/admin/disabledVhbVersion.do?t=' + Date.now(), params)

// -------------消息管理

// 获取消息管理列表
export const messageList = (params = {}) =>
  service.post('/api/admin/systemMessage/getList.do?t=' + Date.now(), params)

// 添加消息
export const addMessage = (params = {}) =>
  service.post(
    '/api/admin/systemMessage/addVhbSystemMessage.do?t=' + Date.now(),
    params
  )

// 修改消息
export const updateMessage = (params = {}) =>
  service.post(
    '/api/admin/systemMessage/updateVhbSystemMessage.do?t=' + Date.now(),
    params
  )

// 删除消息
export const deleteMessage = (params = {}) =>
  service.post(
    '/api/admin/systemMessage/delVhbSystemMessage.do?t=' + Date.now(),
    params
  )

// -------------用户反馈

// 用户反馈
export const feedback = (params = {}) =>
  service.get(
    '/api/admin/Vhbfeedback/getVhbfeedbackList.do?t=' + Date.now(),
    params
  )

// 查询用户反馈
export const searchFeedback = (params = {}) =>
  service.post(
    '/api/admin/Vhbfeedback/getVhbFeedback.do?t=' + Date.now(),
    params
  )

// 处理用户反馈
export const solveFeedback = (params = {}) =>
  service.post(
    '/api/admin/Vhbfeedback/updateStatusVhbfeedback.do?t=' + Date.now(),
    params
  )

// 删除用户反馈
export const deleteFeedback = (params = {}) =>
  service.post(
    '/api/admin/Vhbfeedback/delVhbfeedBack.do?t=' + Date.now(),
    params
  )

// 获取用户反馈图片
export const getFeedbackImg = (params = {}) =>
  service.get('/api/admin/Vhbfeedback/getPic.do?t=' + Date.now(), {
    params: params
  })

// 系统设置

// 修改密码
export const changePassword = (params = {}) =>
  service.post('/api/admin/manager/savePassword.do?t=' + Date.now(), params)

// -----------组织结构

// 菜单列表
export const menu = (params = {}) =>
  service.post('/api/admin/menu/getMenuList.do?t=' + Date.now(), params)

// 组织结构列表
export const organizationList = (params = {}) =>
  service.post('/api/admin/sysoffice/getlist.do?t=' + Date.now(), params)

// 添加组织结构
export const addOrganization = (params = {}) =>
  service.post('/api/admin/sysoffice/addOffice.do?t=' + Date.now(), params)

// 获取修改组织结构信息
export const getChangeOrg = (params = {}) =>
  service.post('/api/admin/sysoffice/getOffice.do?t=' + Date.now(), params)

// 修改组织结构信息
export const updateOrganization = (params = {}) =>
  service.post('/api/admin/sysoffice/updateOffice.do?t=' + Date.now(), params)

// 删除组织结构信息
export const deleteOrganization = (params = {}) =>
  service.post('/api/admin/sysoffice/deleteOffice.do?t=' + Date.now(), params)

// ----------角色管理

// 获取角色管理列表
export const roleData = (params = {}) =>
  service.post('/api/admin/role/getRoleListAll.do?t=' + Date.now(), params)

// 获取菜单权限
export const getmenulist = (params = {}) =>
  service.post('/api/admin/role/getRoleInfo.do?t=' + Date.now(), params)

// 添加菜单权限
export const addMenulist = (params = {}) =>
  service.post('/api/admin/role/saveRoleInfo.do?t=' + Date.now(), params)

// 修改角色->获取信息
export const getUpdateMenu = (params = {}) =>
  service.post('/api/admin/role/getUpdateInfo.do?t=' + Date.now(), params)

// 修改角色->保存修改信息
export const saveUpdateMenu = (params = {}) =>
  service.post('/api/admin/role/roleUpdate.do?t=' + Date.now(), params)

// 删除角色
export const deleteMenu = (params = {}) =>
  service.post('/api/admin/role/roleUpdate.do?t=' + Date.now(), params)

// ---------管理员

// 获取管理员信息
export const getAdmin = (params = {}) =>
  service.get('/api/admin/manager/getUserList.do?t=' + Date.now(), {
    params: params
  })

// 添加/修改管理员获取信息
export const getAdminList = (params = {}) =>
  service.get('/api/admin/manager/userUpdateInfo.do?t=' + Date.now(), {
    params: params
  })

// 添加管理员信息
export const addAdminInfo = (params = {}) =>
  service.post('/api/admin/manager/saveUser.do?t=' + Date.now(), params)

// 保存修改管理员信息
export const saveAdminInfo = (params = {}) =>
  service.post('/api/admin/manager/saveUpdate.do?t=' + Date.now(), params)

// // 删除管理员
export const deleteAdmin = (params = {}) =>
  service.post('/api/admin/manager/saveUpdate.do?t=' + Date.now(), params)

// 菜单管理
// 全部菜单列表
export const getAllMenu = (params = {}) =>
  service.get('/api/admin/menu/getAllMenuList.do?t=' + Date.now(), {
    params: params
  })

// 获取修改菜单信息
export const getMenuInfo = (params = {}) =>
  service.get('/api/admin/menu/getMenuById.do?t=' + Date.now(), {
    params: params
  })

// 修改菜单
export const updateMenu = (params = {}) =>
  service.post('/api/admin/menu/updateMenu.do?t=' + Date.now(), params)

// 删除菜单
export const deleteMenuItem = (params = {}) =>
  service.post('/api/admin/menu/deleteMenu.do?t=' + Date.now(), params)

// 个人信息
export const getUserInfo = (params = {}) =>
  service.get('/api/admin/manager/getUserInfo.do?t=' + Date.now(), {
    params: params
  })

// --------------账单管理---------------

// --------交易账单

// 获取账单列表
export const getBillList = (params = {}) =>
  service.post('/api/paybill/paybilllists.do?t=' + Date.now(), params)

// 导出账单
export const downloadBill = 'https://xiaoyu.jsh178.com/api/paybill/dowland.do?ids='

// 账单详情
export const billDetail = (params = {}) =>
  service.post('/api/paybill/getVhbPayBillView.do?t=' + Date.now(), params)
